<template>
  <el-table :data="tableData" :span-method="spanMethod" :highlight-current-row="false" border>
    <el-table-column label="中央ID" prop="trackId" width="100" fixed="left"></el-table-column>
    <el-table-column label="歌曲基础信息" v-slot="{ row }" width="200" fixed="left">
      <info-item label="歌曲名" :content="row.trackName"></info-item>
      <info-item label="歌手" :content="row.singerText"></info-item>
      <info-item label="版本" :content="row.srcVersion"></info-item>
    </el-table-column>
    <el-table-column label="专辑信息" v-slot="{ row }" width="200" fixed="left">
      <info-item label="专辑名" :content="row.albumBase.albumName"></info-item>
      <info-item label="发行时间" :content="row.albumBase.publicTime"></info-item>
      <info-item label="UPC" :content="row.albumBase.upc"></info-item>
    </el-table-column>
    <el-table-column label="歌曲扩展信息" v-slot="{ row }" width="150">
      <info-item label="ISRC" :content="row.isrc"></info-item>
      <info-item label="词作者" :content="row.wordAuthorText"></info-item>
      <info-item label="曲作者" :content="row.musicAuthorText"></info-item>
    </el-table-column>
    <el-table-column label="歌曲状态" v-slot="{ row }" width="150">
      <span style="margin-bottom:5px">
        状态：{{ statusMap[row.status] }}
        <el-tooltip v-if="row.status === 0" placement="top" content="当歌曲状态为隐藏时，歌曲将暂缓结算">
          <i class="el-icon-warning" style="color:#e6a23c" />
        </el-tooltip>
      </span>
      <info-item label="当前付费口径" :content="paymentTypeMap[row.trackPayment.paymentType]"></info-item>
      <info-item label="隐藏原因" v-if="row.status === 0" :content="hiddenReasonToOuterMap[row.hideReason]"></info-item>
    </el-table-column>
    <!-- <el-table-column label="版权冲突" v-slot="{ row }" width="75">
      <cp-conflict-bar v-if="row.hasLuyinCp" label="录音" :conflict="!!row.cpPercentSign"></cp-conflict-bar>
      <cp-conflict-bar v-if="row.hasWordCp" label="词" :conflict="!!row.wordCpPercentSign"></cp-conflict-bar>
      <cp-conflict-bar v-if="row.hasMusicCp" label="曲" :conflict="!!row.musicCpPercentSign"></cp-conflict-bar>
    </el-table-column> -->
    <el-table-column label="版权类型" v-slot="{ row }">
      {{ authTypeMap[row.authType] }}
    </el-table-column>
    <el-table-column label="版权瑕疵" v-slot="{ row }" width="85">
      {{ cpDefectMap[row.cpDefect] }}
    </el-table-column>
    <el-table-column label="合同号" prop="contract" width="120" show-overflow-tooltip>
    </el-table-column>
    <el-table-column label="版权公司" v-slot="{ row }" width="120" show-overflow-tooltip>
      {{ row.companyName }}
    </el-table-column>
    <el-table-column label="授权周期" v-slot="{ row }" width="180">
      {{ row.copyrightDateText }}
    </el-table-column>
    <el-table-column label="授权百分比" v-slot="{ row }" width="90">
      {{ `${row.cpPercent}%` }}
    </el-table-column>
    <template v-if="ixYxCompanyUser">
      <el-table-column label="是否代理" v-slot="{ row }">
        {{ switchMap[row.isAgent] }}
      </el-table-column>
      <el-table-column label="是否翻唱" v-slot="{ row }">
        {{ switchMap[row.cpSource] }}
      </el-table-column>
    </template>
    <el-table-column label="操作" width="140" v-slot="{ row }">
      <el-popover v-if="row.showPlatformInfo" trigger="hover" placement="right">
        <div v-for="(v,k) in platformMap" :key="k">{{ v }}: {{ platformStatusMap[row.platformInfo[k]]||'' }}</div>
        <el-button slot="reference" type="text">查看平台上架状态</el-button>
      </el-popover>
    </el-table-column>
  </el-table>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import {
  switchMap,
  statusMap,
  versionMap,
  cpDefectMap,
  hiddenReasonToOuterMap,
  platformMap,
  platformStatusMap
} from '@/utils/constants'
import InfoItem from '../InfoItem.vue'
import { paymentTypeMap } from '../../../album/mixin'

const authTypeMap = {
  1: '录音版权',
  2: '词版权',
  3: '曲版权'
}

export default {
  name: 'Songlist',

  components: {
    InfoItem,
  },
  props: {
    rawData: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      switchMap,
      statusMap,
      paymentTypeMap,
      authTypeMap,
      versionMap,
      cpDefectMap,
      hiddenReasonToOuterMap,
      platformMap,
      platformStatusMap,

      loading: true,
      form: {
        status: ''
      },
    }
  },

  computed: {
    ...mapGetters([
      'ixYxCompanyUser'
    ]),
    tableData() {
      const trackCpList = []
      for (const trackObj of this.rawData) {
        const { trackCopyrightList, trackMusicCopyrightList, trackWordCopyrightList, ...trackInfo } = trackObj
        // 处理歌曲字段
        trackInfo.singerText = trackInfo.trackSingerList?.map(v => v.singerName).join('、') ?? ''
        trackInfo.wordAuthorText = trackInfo.trackExtend?.wordAuthor ?? ''
        trackInfo.musicAuthorText = trackInfo.trackExtend?.musicAuthor ?? ''
        trackInfo.albumBase = trackInfo.albumBase ?? {}

        const cpList = []
        if (Array.isArray(trackCopyrightList)) {
          trackInfo.hasLuyinCp = !!trackCopyrightList.length
          trackCopyrightList.forEach(cp => {
            cp.authType = 1
            // 录音版权有就是 100%，无版权则为 0
            cp.cpPercent = cp.cpStatus === 1 ? 100 : 0
            cpList.push(cp)
          })
        }

        if (Array.isArray(trackWordCopyrightList)) {
          trackInfo.hasWordCp = !!trackWordCopyrightList.length
          trackWordCopyrightList.forEach(cp => {
            cp.authType = 2
            cpList.push(cp)
          })
        }

        if (Array.isArray(trackMusicCopyrightList)) {
          trackInfo.hasMusicCp = !!trackMusicCopyrightList.length
          trackMusicCopyrightList.forEach(cp => {
            cp.authType = 3
            cpList.push(cp)
          })
        }

        for (let index = 0; index < cpList.length; index++) {
          const cp = cpList[index]
          // 处理版权字段
          if (cp.copyrightFrom && cp.copyrightTo) {
            cp.copyrightDateText = `${dayjs(cp.copyrightFrom).format('YYYY-MM-DD')} ~ ${dayjs(cp.copyrightTo).format('YYYY-MM-DD')}`
          }

          // 版权状态不关心是否确认无版权，同一当成无版权处理
          cp.cpStatus = cp.cpStatus === -1 ? 0 : cp.cpStatus
          // 版权来源为 9 的表示可以翻唱
          cp.cpSource = cp.cpSource === 9 ? 1 : 0

          // 合同编号以 O-000-FL、O-000-L、MCR-、FREE- 开头或空的屏蔽成/
          if (!cp.contract || ['O-000-FL', 'O-000-L', 'MCR-', 'FREE-'].some(prefix => cp.contract.startsWith(prefix))) {
            cp.contract = '/'
          }

          // 有版权瑕疵或隐藏状态的歌曲不展示平台上架状态
          cp.showPlatformInfo = !(trackInfo.status !== 1 || cp.cpDefect !== 0)

          if (index === 0) {
            cp.rowSpan = cpList.length
          } else {
            cp.rowSpan = 0
          }

          trackCpList.push({ ...trackInfo, ...cp })
        }
      }
      return trackCpList
    }
  },

  methods: {
    // ! 增删列，这里也要同步修改数量
    spanMethod({ row, columnIndex }) {
      return {
        rowspan: columnIndex < 5 ? row.rowSpan : 1,
        colspan: 1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .info-item {
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: 0;
  }
}

::v-deep .el-table .el-table__header th.el-table__cell {
  background-color: #f5f7fa;
}

.table-control {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;

  .pagination {
    margin-top: 0;
  }
}

.table-tip {
  vertical-align: bottom;
  margin-left: 5px;
  color: #666;
}
</style>
